import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Box, Grid, LinearProgress } from '@mui/material';

import { LayoutDashboard } from '../../../shared/layouts';
import { GenericService } from '../../../shared/services';
import { CompanyFilterDTO, UserDTO, DemandDTO, DemandFilterDTO, ValueListDTO, AccessRoleDTO, AccessRoleFilterDTO, PeopleDTO } from '../../../shared/interfaces';
import { ISnackbarAlert, SnackbarAlert, CardList, ToolBar, IDialogActions, ICardActions, ICardColumns, IChipFilter, SelectField, TextFieldInput, KanbanList, ISwitchInputProps } from '../../../shared/components';
import { Delete } from '../../../shared/components/confirm-delete/ConfirmDelete';
import { ListId, LocalStorange } from '../../../shared/environment';
import { CompanyDTO } from '../../../shared/interfaces/corpSphere/CompanyDTO';
import { ProjectMaintenance } from './ProjectMaintenance';


export const Demand: React.FC = () => {

    const [typeList, setTypeList] = useState<ValueListDTO[]>([]);
    const [categoryList, setCategoryList] = useState<ValueListDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [responsibleList, setResposibleList] = useState<PeopleDTO[]>([]);
    const [requesterList, setRequesterList] = useState<PeopleDTO[]>([]);
    const [companyList, setCompanyList] = useState<CompanyDTO[]>([]);
    
    const [demandList, setDemandList] = useState<DemandDTO[]>([]);
    const [demandFilterDTO, setDemandFilterDTO] = useState<DemandFilterDTO>();

    const [cardMoved, setCardMoved] = useState<any>();
    const [checkedKanban, setCheckedKanban] = useState(true);

    const [actionExecuted, setActionExecuted] = useState(false);

    const [newRecord, setNewRecord] = useState('');
    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');
    const [expadedData, setExpandedData] = useState('');
    const [isOpenMaintenance, setIsOpenMaintenance] = useState(false);
    const [proposal, setProposal] = useState('');

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setDemandFilterDTO({
            ...demandFilterDTO,
            name: '',
            code: '',
            externalCode: '',
            typeId: '',
            categoryId: '',
            statusId: '',
            responsibleId: '',
            requesterId: '',
            companyId: ''
        } as DemandFilterDTO);
    }, []);


    useEffect(() => {
        handleListGetAll(ListId.worksphere.demand.categoryId, setCategoryList);
        handleListGetAll(ListId.worksphere.demand.typeId, setTypeList);
        handleListGetAll(ListId.worksphere.demand.statusId, setStatusList);

        handleCompanyGetAll();
        handleDemandGetAllViewAsync();

        handleGetPermission(ListId.worksphere.demandId, setAccessRolePermissionDTO);
    }, [demandFilterDTO]);

    useEffect(() => {
        if (actionExecuted)
            handleDemandGetAllViewAsync();
    }, [actionExecuted]);

    useEffect(() => {
        handleMoveTaskKanbanAsync();
    }, [cardMoved]);

    useEffect(() => {
        handlePeopleGetAllAsync(setResposibleList);
        handlePeopleGetAllAsync(setRequesterList);
    }, [demandFilterDTO?.companyId]);
    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList);
    }, []);

    const handleMoveTaskKanbanAsync = useCallback(async () => {
        if (cardMoved === undefined || cardMoved.id === undefined || cardMoved.statusId === undefined) {
            return;
        }
        const demandId = cardMoved.id;
        const statusId = cardMoved.statusId;
        const index = cardMoved.index;

        const demandDTO = {
            id: demandId,
            statusId: statusId,
            kanbanIndex: index,
            updatedById: userInfo.user.Id
        };
        GenericService.PostGenericAsync1('worksphere.demand', 'MoveTaskKanbanAsync', demandDTO, setActionExecuted, setLoading, showMessage);
    }, [cardMoved]);

    const handleCompanyGetAll = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.company', companyFIlterDTO, setLoading, setCompanyList, showMessage);
    }, []);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'valueindex, value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handlePeopleGetAllAsync = useCallback(async (setList: any) => {
        const userFilterDTO = {
            companyId: demandFilterDTO?.companyId,
        };
        GenericService.GetAllAsync1('corpsphere.people', userFilterDTO, setLoading, setList, showMessage);
    }, [demandFilterDTO]);

    const handleDemandGetAllViewAsync = useCallback(async () => {
        if (demandFilterDTO === undefined)
            return;
        if (accessRolePermissionDTO?.allowGetAllView == undefined)
            return;
        if (!accessRolePermissionDTO?.allowGetAllView) {
            showMessage('There is no permission for get all view.', 'info');
            return;
        } 
        GenericService.GetAllViewAsync1('worksphere.demand', demandFilterDTO, setActionExecuted, setLoading, setDemandList, showMessage, true);
    }, [demandFilterDTO, accessRolePermissionDTO]);

    const handleClearFilterClick = () => {
        setDemandFilterDTO({
            ...demandFilterDTO,
            name: '',
            code: '',
            externalCode: '',
            statusId: '',
            responsibleId: '',
            requesterId: '',
            typeId: '',
            companyId: userInfo.user.companyId
        } as DemandFilterDTO);
    };

    function handleSearchClick() {
        handleDemandGetAllViewAsync();
    }

    const handleNew = () => {
        if (!accessRolePermissionDTO?.allowAdd) {
            showMessage('There is no permission for new record.', 'info');
            return;
        }
        setNewRecord('data');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setProposal('');
    };

    const handleViewDetatils = (data: string) => {
        if (!accessRolePermissionDTO?.allowGetById) {
            showMessage('There is no permission for view details.', 'info');
            return;
        }
        setNewRecord('');
        setEditRecord(data);
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setProposal('');
    };

    const handleDelete = (data: string) => {
        if (!accessRolePermissionDTO?.allowDelete) {
            showMessage('There is no permission for delete record.', 'info');
            return;
        }
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord(data);
        setIsOpenMaintenance(true);
        setProposal('');
    };

    const handleProposal = (data: string) => {
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setProposal(data);
    };

    const toolBarActions: IDialogActions[] = [
        { id: 'new', text: 'New Project', icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleNew },
    ];

    const cardActions: ICardActions[] = [
        { id: 'viewDetails', toolTip: 'View Details', icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'delete', toolTip: 'Delete', icon: 'delete_outlined', iconColor: 'error', setAction: handleDelete },
    ];

    const chipFilters: IChipFilter[] = [
        { label: 'Total Records', value: demandList.length },
        { label: 'Name', value: demandFilterDTO?.name },
        { label: 'Code', value: demandFilterDTO?.code },
        { label: 'External Code', value: demandFilterDTO?.externalCode },
        { label: 'Type', value: typeList.find(x => x.id === demandFilterDTO?.typeId)?.value },
        { label: 'Category', value: categoryList.find(x => x.id === demandFilterDTO?.categoryId)?.value },
        { label: 'Status', value: statusList.find(x => x.id === demandFilterDTO?.statusId)?.value },
        { label: 'Responsible', value: responsibleList.find(x => x.id === demandFilterDTO?.responsibleId)?.fullName },
        { label: 'Requester', value: requesterList.find(x => x.id === demandFilterDTO?.requesterId)?.fullName },
        { label: 'Company', value: companyList.find(x => x.id === demandFilterDTO?.companyId)?.id },
    ];

    const columns: ICardColumns[] = [
        { field: 'code', label: 'code', size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'name', label: 'Name', size: 4, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'startDateTime', label: 'Start Date', size: 2, type: 'date', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'expectedClosingDateTime', label: 'Expected Closing', size: 2, type: 'date', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'estimatedEffort', label: 'Estimated Effort (hrs)', size: 1, type: 'decimal', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'type', label: 'Type', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: false },
        { field: 'responsible', label: 'Responsible', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: false },
        { field: 'requester', label: 'Requester', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: false },
        { field: 'status', label: 'Status', size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: false },
        { field: 'priority', label: 'Priority', size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: false },
        { field: 'company', label: 'Company', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },

    ];

    const kanbanColumns: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'code', label: 'code', size: 12, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'startDateTime', label: 'Start Date', size: 12, type: 'date', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'expectedClosingDateTime', label: 'Expected Closing', size: 12, type: 'date', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'responsible', label: 'Responsible', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'requester', label: 'Requester', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'company', label: 'Company', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },

    ];

    const kanbanSwitch: ISwitchInputProps = {
        id: 'demand.switch', label: 'View Kanban|View List', checked: checkedKanban, setChecked: setCheckedKanban, disabled: false, autoFocus: false, color: 'info', size: 'small', labelPlacement: 'end'
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }

    return (
        <React.Fragment>
            {isOpenSnackBar && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenSnackBar}
                />
            )}
            <LayoutDashboard title='DEMAND'>
                <ToolBar
                    clickSearch={handleSearchClick}
                    clickClearFilter={handleClearFilterClick}
                    chipFilters={chipFilters}
                    actions={toolBarActions}
                    kanbanSwitch={kanbanSwitch}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='name'
                                label='Name'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.name}
                                obj={demandFilterDTO}
                                placeholder={'Name'}
                                maxLength={200}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='code'
                                label='Code'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.code}
                                obj={demandFilterDTO}
                                placeholder={'Code'}
                                maxLength={200}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='externalCode'
                                label='External Code'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.externalCode}
                                obj={demandFilterDTO}
                                placeholder={'External Code'}
                                maxLength={200}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='statusId'
                                label='Status'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.statusId}
                                obj={demandFilterDTO}
                                valueList={statusList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='companyId'
                                label='Company'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.companyId}
                                obj={demandFilterDTO}
                                valueList={companyList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='responsibleId'
                                label='Responsible'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.responsibleId}
                                obj={demandFilterDTO}
                                valueList={responsibleList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='requesterId'
                                label='Requester'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.requesterId}
                                obj={demandFilterDTO}
                                valueList={requesterList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='typeId'
                                label='Type'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.typeId}
                                obj={demandFilterDTO}
                                valueList={typeList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='categoryId'
                                label='Category'
                                setValue={setDemandFilterDTO}
                                value={demandFilterDTO?.categoryId}
                                obj={demandFilterDTO}
                                valueList={categoryList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                    </Grid>
                </ToolBar>
                {loading && (
                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                )}
                {checkedKanban ? (
                    <Box sx={{ display: 'flex', height: 'calc(100vh - 280px)', minHeight: 520, width: '100%', overflow: 'hidden' }}>
                        <KanbanList
                            identifierField='statusId'
                            cards={demandList}
                            attributes={kanbanColumns}
                            statusList={statusList}
                            setRowExpanded={setExpandedData}
                            setCardMoved={setCardMoved}
                            actions={cardActions}
                            cardSize={2}
                        />
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', maxHeight: '80vh', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                        <CardList
                            columns={columns}
                            rows={demandList}
                            actions={cardActions}
                            cardSize={12}
                            hasChildren={false}
                            setRowExpanded={() => void undefined}
                        />
                    </Box>
                )}
                {newRecord && (
                    <ProjectMaintenance
                        data={''}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {editRecord && (
                    <ProjectMaintenance
                        data={editRecord}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {deleteRecord && (<Delete
                    entity={'worksphere.demand'}
                    data={deleteRecord}
                    setIsOpenDiaglog={setIsOpenMaintenance}
                    isOpenDialog={isOpenMaintenance}
                    setActionExecuted={setActionExecuted}
                />)}
            </LayoutDashboard>
        </React.Fragment >
    );
};
